export function TermsOfServicePage() {
    return (
        <div className="min-h-screen pt-40 pb-24">
            <div className="max-w-3xl mx-auto px-6">
                <div className="mb-16">
                    <p className="uppercase tracking-[0.3em] text-sm text-stone-400 mb-4 font-light">Legal</p>
                    <h1 className="font-serif text-5xl md:text-7xl font-light italic">Terms of Service</h1>
                </div>
                <div className="space-y-10 text-sm text-stone-600 font-light leading-relaxed">
                    <div>
                        <h2 className="font-serif text-xl font-light italic text-stone-900 mb-3">Orders & payment</h2>
                        <p>By placing an order you confirm that all information provided is accurate. We reserve the right to cancel orders in the event of pricing errors or stock unavailability, in which case a full refund will be issued promptly.</p>
                    </div>
                    <div>
                        <h2 className="font-serif text-xl font-light italic text-stone-900 mb-3">Intellectual property</h2>
                        <p>All content on this site — including photographs, copy, and design — is the property of Beetrele Ltd and may not be reproduced without written permission.</p>
                    </div>
                    <div>
                        <h2 className="font-serif text-xl font-light italic text-stone-900 mb-3">Limitation of liability</h2>
                        <p>We are not liable for indirect or consequential losses arising from the use of our products. Our total liability shall not exceed the value of your order. Nothing in these terms affects your statutory rights as a consumer.</p>
                    </div>
                    <div>
                        <h2 className="font-serif text-xl font-light italic text-stone-900 mb-3">Governing law</h2>
                        <p>These terms are governed by the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the English courts.</p>
                    </div>
                    <p className="text-xs text-stone-400 pt-4 border-t border-stone-100">Last updated: March 2026</p>
                </div>
            </div>
        </div>
    );
}
